import React, { ReactNode } from 'react';
import ConditionalRender from '../../../helpers/ConditionalRender';
import { DATA_FAILED, DATA_LOADED, DATA_LOADING, VIEW_MODE } from '../../Constants';

export interface HostChartCardProps {
    cardTitle: string;
    chartTitle: string;
    collapseId: string;
    peakLabel: string;
    peakValue: number | null;
    peakSuffix?: string;
    mode: number;
    onToggleMode: () => void;
    loading: number;
    children: ReactNode;
}

function HostChartCard(props: HostChartCardProps) {
    return (
        <div className="card collapsible">
            <div className="card-header">
                <i className="fal fa-chart-bar fa-fw" aria-hidden="true"/>
                {props.cardTitle}
                <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                   data-bs-target={`#${props.collapseId}`} aria-expanded="false"
                   aria-controls={props.collapseId}/>
                <div className="btn-group float-end">
                    <button type="button" className="btn btn-xsm btn-primary float-end ms-1"
                            onClick={props.onToggleMode}>{((props.mode === VIEW_MODE.BASIC) ? 'Show Breakdown' : 'Show Summary')}</button>
                </div>
            </div>
            <div id={props.collapseId} className="card-body collapse show p-0">
                <div className="row row-cols-1">
                    <div className="col p-3">
                        <React.Fragment>
                            <h4 className='icons-chart-title'>
                                {props.chartTitle}
                                <ConditionalRender if={props.peakValue !== null && Number.isFinite(props.peakValue)}>
                                    <span className="peak">{props.peakLabel} {Math.round(props.peakValue as number)}{props.peakSuffix ?? ''}</span>
                                </ConditionalRender>
                            </h4>

                            <ConditionalRender if={props.loading === DATA_LOADING}>
                                <div className="w-100 text-center text-muted mt-3">
                                    <div className="loader spinner chartSpinner">
                                    </div>
                                    <p className="mt-3">
                                        Loading data...
                                    </p>
                                </div>
                            </ConditionalRender>

                            <ConditionalRender if={props.loading === DATA_FAILED}>
                                <div className="w-100 text-center text-muted mt-3">
                                    <p>No data found</p>
                                </div>
                            </ConditionalRender>

                            <ConditionalRender if={props.loading === DATA_LOADED}>
                                {props.children}
                            </ConditionalRender>
                        </React.Fragment>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HostChartCard;
